import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { getIsUrlRecognized } from "@faire/retailer/serialized-data/getIsUrlRecognized";

export const AppRoutesEffects = () => {
  const history = useHistory();
  const { pathname } = useLocation();

  // 2023/02/03 hamidreza.hanafi@faire.com
  // We only want to redirect the user to `/pagenotfound` once, so that they're still
  // able to navigate away from it (the `isUrlUnrecognized` value in
  // `PageSerializedData` is backend-driven and won't change.)
  // See FD-125907 for more details on why this is.
  const [hasRedirectedToPageNotFound, setHasRedirectedToPageNotFound] =
    useState(false);
  useEffect(() => {
    if (hasRedirectedToPageNotFound) {
      return;
    }
    if (!getIsUrlRecognized() && pathname !== "/pagenotfound") {
      history.push("/pagenotfound");
      setHasRedirectedToPageNotFound(true);
    }
  }, [hasRedirectedToPageNotFound, history, pathname]);

  return null;
};
